import { Link } from 'react-router-dom';

const stats = [
  { value: '12,000+', label: '收录影片' },
  { value: '8,600+', label: '资讯文章' },
  { value: '36', label: '影片类型' },
  { value: '每日', label: '持续更新' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-primary-800 px-4 py-14 md:px-6 md:py-16">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            关于草民电影
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
            草民电影是一个专注影视内容分享与资讯更新的平台。我们每天整理最新电影动态、整理影片资料，
            用清晰的结构帮你在海量影片中快速找到想了解的那一部。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-background-300 md:text-base">
            从票房与行业消息，到影片的导演、主演、评分与剧情简介，这里都有。愿每一次打开，都能遇见一部好电影。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              了解我们
            </Link>
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md border border-background-100/50 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-primary-700 bg-primary-900/60 p-5 text-center"
            >
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1.5 text-sm text-background-300">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}